<template>
  <ContentContainer :loadingStatus="isLoading">
    <div class="market content-wrapper">
      <div class="page-header">{{ $t('newMarket') }}</div>
      <div style="margin-bottom: 40px; margin-left: 5px;">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ name: 'SettingMarketList' }">{{ $t('market') }}</el-breadcrumb-item>
          <el-breadcrumb-item>{{ $t('newMarket') }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <el-form ref="form" label-width="150px" style="width: 500px">
        <el-form-item :label="$t('name')" :required="true">
          <el-input v-model="market.name"></el-input>
        </el-form-item>
        <el-form-item :label="$t('description')">
          <el-input type="textarea" v-model="market.detail"></el-input>
        </el-form-item>
        <el-form-item :label="$t('status')">
          <el-radio-group v-model="market.isEnable" fill="#ff0000" >
            <el-radio :label="STATUS.ENABLE">{{ $t('STATUS.ENABLE') }}</el-radio>
            <el-radio :label="STATUS.DISABLE">{{ $t('STATUS.DISABLE') }}</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <el-form ref="form" label-width="150px" style="width: 100%; margin-top: 40px">
        <el-form-item>
          <el-button type="primary" @click="onCreateMarketButtonClick">{{ $t('createMarket') }}</el-button>
          <el-button type="info" @click="onCreateMarketAndContinueAddAgentButtonClick">{{ $t('createMarketAndContinueAddAgent') }}</el-button>
          <el-button type="default" @click="onCancelButtonClick">{{ $t('cancel') }}</el-button>
        </el-form-item>
      </el-form>
    </div>
  </ContentContainer>
</template>

<script>
import { STATUS } from '@/configs/constant'
import i18nMessages from '@/translations/Setting/ManageSetting/Market/Add.i18n'
import AlertViewMixin from '@/mixins/alert-view-mixin'
import LoadingViewMixin from '@/mixins/loading-view-mixin'
import NotificationMixin from '@/mixins/notification-mixin'
import ContentContainer from '@/components/ContentContainerComponent'
import SettingMarketApi from '@/api/setting/market-api'

export default {
  name: 'SettingMarketAdd',
  mixins: [AlertViewMixin, LoadingViewMixin, NotificationMixin],
  components: { ContentContainer },
  i18n: { messages: i18nMessages },
  data () {
    return {
      isLoading: false,
      STATUS,
      market: {
        name: '',
        detail: '',
        isEnable: STATUS.DISABLE
      }
    }
  },
  methods: {
    onCreateMarketButtonClick: async function () {
      try {
        this.startLoading()

        await this._addMarket(this.market)

        this.$router.push({
          name: 'SettingMarketList'
        })
      } catch (err) {
        this.alertError(err.message)
      }

      this.stopLoading()
    },
    onCreateMarketAndContinueAddAgentButtonClick: async function () {
      try {
        this.startLoading()

        const marketData = await this._addMarket(this.market)

        this.$router.push({
          name: 'SettingMarketEdit',
          params: {
            market: marketData
          }
        })
      } catch (err) {
        this.alertError(err.message)
      }

      this.stopLoading()
    },
    onCancelButtonClick: function () {
      this.$router.push({
        name: 'SettingMarketList'
      })
    },
    _addMarket: async function (marketData) {
      const newMarket = await SettingMarketApi.create(marketData)
      newMarket.agentIdList = []

      const title = this.$t('createMarketSuccessTitle')
      const message = this.$t('createMarketSuccessMessage')
      this.showNotificationSuccess(title, message)

      return newMarket
    }
  }
}
</script>

<style scoped>
  .el-form > div {
    text-align: left;
  }
</style>
